import { Link, NavLink } from "react-router-dom";
import { Instagram, Mail, Menu, MessageCircle, ShoppingBag, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { navItems } from "../data/siteContent";

export function Layout({ children, cartCount, onCartOpen, contact }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const cleanNumber = contact.whatsapp_number.replace(/\D/g, "") || "910000000000";

  return (
    <div className="site-shell" data-testid="site-shell">
      <header className="site-header" data-testid="site-header">
        <Link to="/" className="brand-mark" data-testid="brand-home-link">
          <span data-testid="brand-name">Project Umeed</span>
          <small data-testid="brand-tagline">Women-led craft from Kutch</small>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation" data-testid="desktop-navigation">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} data-testid={`nav-link-${item.label.toLowerCase().replaceAll(" ", "-")}`}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          <a className="header-icon-link" href={`https://wa.me/${cleanNumber}`} target="_blank" rel="noreferrer" data-testid="header-whatsapp-link" aria-label="WhatsApp Project Umeed">
            <MessageCircle aria-hidden="true" />
          </a>
          <Button className="cart-button" onClick={onCartOpen} data-testid="header-cart-button">
            <ShoppingBag aria-hidden="true" /> Cart <span data-testid="header-cart-count">{cartCount}</span>
          </Button>
          <Button className="mobile-menu-button" variant="outline" size="icon" onClick={() => setMenuOpen((value) => !value)} data-testid="mobile-menu-toggle-button">
            {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </Button>
        </div>
      </header>
      {menuOpen && (
        <nav className="mobile-nav" data-testid="mobile-navigation">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} onClick={() => setMenuOpen(false)} data-testid={`mobile-nav-link-${item.label.toLowerCase().replaceAll(" ", "-")}`}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
      <main data-testid="main-content">{children}</main>
      <footer className="site-footer" data-testid="site-footer">
        <div>
          <h2 data-testid="footer-title">Carry beauty. Create access.</h2>
          <p data-testid="footer-copy">Premium handmade textile products by women artisans from Kutch, built for conscious buyers, gifting clients and global markets.</p>
        </div>
        <div className="footer-links" data-testid="footer-links">
          <Link to="/collaborate" data-testid="footer-collaborate-link">Collaborate</Link>
          <Link to="/corporate-gifting" data-testid="footer-gifting-link">Gifting</Link>
          <a href={`mailto:${contact.email}`} data-testid="footer-email-link"><Mail aria-hidden="true" /> {contact.email}</a>
          <a href={`https://instagram.com/${contact.instagram_handle.replace("@", "")}`} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram aria-hidden="true" /> {contact.instagram_handle}</a>
        </div>
      </footer>
    </div>
  );
}